const noticeText =
  'Data generated on this platform may be accessible to authorized administrators for research governance, platform support, and quality assurance. We do not sell, share, or use this data for any third-party purpose.';

const AuthDataNotice = ({ variant = 'light' }) => {
  const isDark = variant === 'dark';

  return (
    <div
      className={
        isDark
          ? 'rounded-lg border border-slate-200 bg-slate-50 p-3 text-left'
          : 'rounded-lg border p-3 text-left'
      }
      style={
        isDark
          ? null
          : {
              background: '#F6F5F3',
              borderColor: '#E2E0DA',
            }
      }
    >
      <p
        className="text-xs leading-5"
        style={isDark ? null : { color: '#5C5C5C', margin: 0 }}
      >
        {noticeText}
      </p>
    </div>
  );
};

export default AuthDataNotice;
